import { render, staticRenderFns } from "./tags-page-opened.vue?vue&type=template&id=71f06342&"
import script from "./tags-page-opened.vue?vue&type=script&lang=ts&"
export * from "./tags-page-opened.vue?vue&type=script&lang=ts&"
import style0 from "./tags-page-opened.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tags-page-opened.vue"
export default component.exports